import type {PartialOptions} from "../../../../../../stem-core/ui/UIBase";
import {UI} from "../../../../../../stem-core/ui/UIBase";
import {NOOP_FUNCTION} from "../../../../../../stem-core/base/Utils";
import {PaymentMethod} from "../../../../../../client/state/PaymentMethodStore";
import {autoredraw} from "../../../../../../stem-core/decorators/AutoRedraw";
import {PaymentMethodSelectInput} from "./PaymentMethodSelectInput.jsx";


// TODO @cleanup this is crap
interface ChooseCardComponentOptions {
    entry?: any;
    initialValue?: any;
    onAddCard?: (...args: any[]) => void;
    onChange?: (...args: any[]) => void;
}

@autoredraw(PaymentMethod)
export class ChooseCardComponent extends UI.Element<ChooseCardComponentOptions> {
    declare value?: any;
    getDefaultOptions(): PartialOptions<ChooseCardComponent> {
        return {
            initialValue: null,
            onAddCard: NOOP_FUNCTION,
            onChange: NOOP_FUNCTION,
            testId: "chooseCard",
            entry: null,
        };
    }

    constructor(...args: ConstructorParameters<typeof UI.Element<ChooseCardComponentOptions>>) {
        super(...args);

        this.value = this.options.initialValue;
    }

    isValid() {
        return true;
    }

    getActive() {
        return this.value;
    }

    async getPaymentMethod() {
        return this.value;
    }

    handleCardSelection(card: PaymentMethod) {
        this.value = card;
        this.redraw();
        this.options.onChange(card);
    }

    render() {
        const {onAddCard, entry} = this.options; // TODO @cleanup entry should be rename to something else/removed

        return [
            <PaymentMethodSelectInput
                initialValue={this.value}
                onChange={(card) => this.handleCardSelection(card)}
                onAddCard={onAddCard}
                showHeader={true}
                recurringPayment={entry}
                showDescription={true}
            />,
        ]
    }
}
